@defer (when wallet.showFundingModal()) {
<app-funding-modal
  [showModal]="wallet.showFundingModal()"
  (closeModal)="wallet.showFundingModal.set(false)"
></app-funding-modal>
} @defer (when cpuModalOpen() && !mobile.isMobile; prefetch on idle) {
<app-cpu-team-modal
  [showModal]="cpuModalOpen()"
  (closeModal)="cpuModalOpen.set(false)"
></app-cpu-team-modal>
} @defer (when partyBuilderOpen(); prefetch on idle) {
<app-party-builder-modal
  [showModal]="partyBuilderOpen()"
  (closeModal)="partyBuilderOpen.set(false)"
></app-party-builder-modal>
} @defer (when lobby.pendingSignedDirectChallenge(); prefetch on idle) {
  @if (lobby.pendingSignedDirectChallenge(); as dc) {
  <app-direct-challenge-modal
    [challenge]="dc"
    [pending]="lobby.challengePending()"
    (accept)="lobby.acceptSignedDirectChallenge()"
    (dismissChallenge)="lobby.dismissSignedDirectChallenge()"
  ></app-direct-challenge-modal>
  }
}
<app-party-invite-card></app-party-invite-card>

<div class="container">

  @if(!mobile.isMobile) {
  <app-header></app-header>
  }

  <div class="layout">
    @if (!mobile.isMobile) {
    <div class="content">
      <div class="top">
        <div class="lineup-split">
          <app-team-select mode="home" [dropDown]="true"></app-team-select>
          <app-daily-challenge-card></app-daily-challenge-card>
        </div>
        <app-battle-actions
          [hasTeam]="lobby.hasTeam()"
          [challengePending]="lobby.challengePending()"
          (cpuBattle)="cpuModalOpen.set(true)"
          (customGame)="partyBuilderOpen.set(true)"
          (cancelChallenge)="lobby.cancelDirectChallenge()"
        ></app-battle-actions>
        @if (lobby.queueJoinError(); as msg) {
        <div class="queue-error" role="alert">{{ msg }}</div>
        }
        <app-gacha-cta-strip></app-gacha-cta-strip>
        <app-queue-listings-strip></app-queue-listings-strip>
      </div>

      <app-recent-battles [carousel]="true"></app-recent-battles>

      <app-lobby-feed
        [hasTeam]="lobby.hasTeam()"
        (openOnboarding)="lobby.onOpenOnboardingFromCta()"
      ></app-lobby-feed>

      <app-online-players-sidebar
        [challengePending]="lobby.directedChallengePending()"
        [defaultMode]="lobby.battleMode()"
        (challenge)="lobby.handleDirectedChallenge($event)"
        (editSelf)="lobby.openUsernameEditor()"
      ></app-online-players-sidebar>
    </div>
    } @else {
    <!-- MOBILE: battle-first column; PLAY opens the full-screen mode sheet -->
    <div class="mobile">
      <app-nav-bar></app-nav-bar>
      <app-queue-listings-strip></app-queue-listings-strip>
      <app-lobby-feed
        [hasTeam]="lobby.hasTeam()"
        (openOnboarding)="lobby.onOpenOnboardingFromCta()"
      ></app-lobby-feed>
      <app-gacha-cta-strip></app-gacha-cta-strip>
      @if (lobby.queueJoinError(); as msg) {
      <div class="queue-error" role="alert">{{ msg }}</div>
      }
      <button type="button" class="play-cta" (click)="playSheetOpen.set(true)">PLAY</button>

      <!-- Inside the sticky column: .mobile is a stacking context (sticky), so
           the sheet must share it for the nav's higher z-index to win. -->
      <app-online-players-sheet
        [challengePending]="lobby.directedChallengePending()"
        [defaultMode]="lobby.battleMode()"
        (challenge)="lobby.handleDirectedChallenge($event)"
      ></app-online-players-sheet>

      @defer (when playSheetOpen(); prefetch on idle) {
        @if (playSheetOpen()) {
        <app-play-sheet
          (close)="playSheetOpen.set(false)"
          (customGame)="partyBuilderOpen.set(true)"
        ></app-play-sheet>
        }
      }
    </div>
    }
  </div>
</div>

@defer (on idle) {
  <app-profile-preview-card></app-profile-preview-card>
}
